import Button from "@material-ui/core/Button";
import Aos from "aos";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import "./Section.scss";

function Section() {

	Aos.init({
		delay: 500,
		once: true
	});
	return (
		<div className="SectionFive">
			<div className="sec5">
				<div className="container">
					<div className="awards">
						<div className="col-md-7 col-md-4 row hidetab"></div>
						<div className="sec5Head col-lg-5 col-md-8" data-aos="zoom-in">
							<h6 className="small-title" data-aos="flip-right">
								Founder and CEO
							</h6>
							<h6 className="title" data-aos="flip-up">
								Mr Mohammad Ali
							</h6>
							<p data-aos="flip-down">
							Mr. Mohammad Ali (G.G.), the founder of<span className="GGIFont"> Galaxy Gemological Institute </span> (GGI)  comes from a distinguished lineage of jewelry retailers. This rich heritage, spanning over four generations, has instilled in him an unparalleled understanding of the gems and jewelry industry.

							</p>
							<p data-aos="flip-down">
								Feeling the need of the industry Mohammad Ali established Galaxy Gemological
								Institute, where they provide diamond and gemstones testing in Karachi. He is also
								serving as:
							</p>
							<div className="progressDiv">
								<div className="progressName">
									<h6>Independent Director on Board of Directors</h6>
									<h6>Pakistan Industrial development Corporation (PIDC)</h6>
								</div>
							</div>
							<div className="progressDiv">
								<div className="progressName">
									<h6>Senior Vice Chairman</h6>
									<h6>All Pakistan Commercial Exporters Association (APCEA)</h6>
								</div>
							</div>
							<Link to="/about/Owner" className="Link">
								<Button className="button">More About CEO</Button>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Section);
